import React from 'react';

export const PromoCard: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => <div className={`dc ${className}`.trim()}>{children}</div>;

export const PromoCardHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="dc-h">{children}</div>
);

export const PromoCardTitle: React.FC<{ icon?: React.ReactNode; children: React.ReactNode }> = ({
  icon,
  children,
}) => (
  <div className="dc-t">
    {icon}
    {children}
  </div>
);

export const PromoCardDesc: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="dc-d">{children}</p>
);

export const PromoCardBody: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => <div className={`dc-c ${className}`.trim()}>{children}</div>;
